import { Fragment, useEffect, useMemo, useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import PlaceIcon from "@mui/icons-material/Place";
import TableRestaurant from "@mui/icons-material/TableRestaurant";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import AddBox from "@mui/icons-material/AddBox";

import { PageLink, availableWorkshopLocations, userCanEditPerfume } from "@/models";
import type { WorkshopLocation } from "@/models";
import { useAuthentication } from "@/services";
import { services } from "@/injectServices";
import { useTranslation } from "react-i18next";

const localStorageLogoClickCountKey = "home-logo-click-count";

export function HomePage() {
  useEffect(() => {
    document.title = `Galimard Workshop: Home`;
  });

  const [logoClickCount, setLogoClickCount] = useState<number>(() => {
    // retrive existing click count
    return parseInt(localStorage.getItem(localStorageLogoClickCountKey) || "0") || 0;
  });

  // store logoClickCount in local storage
  useEffect(() => {
    localStorage.setItem(localStorageLogoClickCountKey, `${logoClickCount}`);
  }, [logoClickCount]);

  const { user } = useAuthentication(services().authenticationService);

  const showCreatePerfume = logoClickCount > 4 && userCanEditPerfume(user);

  const orderWorkshopLink = "https://www.galimard.com/categorie-produit/ateliers-paris";

  const { t } = useTranslation();
  return (
    <Container>
      {
        !showCreatePerfume && (
          <Card sx={{ maxWidth: "350px", mx: "auto", mt: 2 }}>
            <CardMedia
              onClick={() => setLogoClickCount((c) => c + 1)}
              component="img"
              // height="140"
              image="/atelier-grasse-particuliers-550x371.jpg"
              alt="galimard logo"
            />
            <CardActionArea href={orderWorkshopLink}>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {t("atelierDeCreationParis")}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t("atelierDeCreationPromo")}
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button variant="outlined" size="small" color="secondary" href={orderWorkshopLink}>
                {t("bookButtonTitle")}
              </Button>
            </CardActions>
          </Card>
        )
        // <Box display="flex" alignItems="center" flexDirection="column" sx={{}}>
        //   <Box
        //     sx={{
        //       maxWidth: "200px",
        //     }}
        //     onClick={() => setLogoClickCount((c) => c + 1)}
        //     component="img"
        //     src="/galimard-logo-noir-sans-baseline.svg"
        //   />

        //   <Typography>Perfume creation workshop</Typography>
        //   <Box component="img" src="/atelier-grasse-particuliers-550x371.jpg"/>
        //   <a href="https://www.galimard.com/categorie-produit/ateliers-paris"><Typography>Réservation sur galimard.com</Typography></a>
        // </Box>
      }

      {showCreatePerfume && (
        <Paper
          sx={{
            m: 1,
            p: 2,
          }}
        >
          <List component="nav" subheader={<ListSubheader>Workshops Locations</ListSubheader>}>
            {availableWorkshopLocations.map((w) => (
              <Fragment key={w.workshopLocationId}>
                <ListItem>
                  <ListItemIcon>
                    <PlaceIcon />
                  </ListItemIcon>
                  <ListItemText primary={w.name} secondary={w.address} />
                </ListItem>

                <WorkshopItem workshopLocation={w} />
              </Fragment>
            ))}
          </List>
        </Paper>
      )}
    </Container>
  );
}

function WorkshopItem({ workshopLocation }: { workshopLocation: WorkshopLocation }) {
  const workshopLocationLink = PageLink.workshopLocation({
    workshopLocationId: workshopLocation.workshopLocationId,
  });

  const workshopLocationLinkCreate = `${workshopLocationLink}?create=1`;

  const UrlCreate = useMemo(() => {
    return new URL(workshopLocationLinkCreate, window.location.origin).toString();
  }, [workshopLocationLinkCreate]);

  return (
    <Card sx={{ minWidth: 250, backgroundColor: "#fafafa" }}>
      <CardHeader
        avatar={
          <RouterLink to={workshopLocationLink}>
            <TableRestaurant />
          </RouterLink>
        }
        title={`Location ${workshopLocation.name}`}
        // subheader={lastPerfumeLink && <Link component={RouterLink} to={lastPerfumeLink}>{lastPerfumeStatusText}</Link>}
      />
      <Button
        component={RouterLink}
        sx={{
          marginLeft: "auto",
        }}
        to={UrlCreate}
        size="small"
        startIcon={<AddBox />}
      >
        Créer un parfum
      </Button>
    </Card>
  );
}
